import React from "react";
import { useTranslation } from "react-i18next";
import { getSettings } from "src/services/configService";

import { useCurrentSubscriptionExpired, useSubscriptionExpiringWithinMonth } from "@dashboard/workspaces/api/helpers";
import { CustomAlert } from "@shared/CustomAlert/CustomAlert";
import { PrimaryButton } from "@shared/CustomButton";

type SubscriptionAlertProps = {
    style?: React.CSSProperties;
};

export const SubscriptionAlert = (props: SubscriptionAlertProps) => {
    const { t } = useTranslation(["pages"]);
    const isExpired = useCurrentSubscriptionExpired();
    const isExpiringWithinMonth = useSubscriptionExpiringWithinMonth();
    const { pricingUrl } = getSettings().features;

    const renewButton = pricingUrl ? (
        <PrimaryButton onClick={() => window.open(pricingUrl, "_blank", "noopener,noreferrer")}>
            {t("pages:workspacePage.button.renewSubscription")}
        </PrimaryButton>
    ) : null;

    if (isExpired) {
        return (
            <CustomAlert
                title={t("pages:workspacePage.section.subscriptionAlert.expiredTitle")}
                severity="error"
                action={renewButton}
                style={props.style}
            >
                {t("pages:workspacePage.section.subscriptionAlert.expiredDescription")}
            </CustomAlert>
        );
    }

    if (isExpiringWithinMonth) {
        return (
            <CustomAlert
                title={t("pages:workspacePage.section.subscriptionAlert.expiringTitle")}
                severity="warning"
                action={renewButton}
                style={props.style}
            >
                {t("pages:workspacePage.section.subscriptionAlert.expiringDescription")}
            </CustomAlert>
        );
    }

    return null;
};
